import React, { useRef } from "react";
import CopyCodeButton from "./CopyCodeButton";

const PreCodeBlock: React.FC<React.HTMLAttributes<HTMLPreElement>> = ({
  className,
  children,
  ...rest
}) => {
  const preRef = useRef<HTMLPreElement>(null);

  return (
    <div className={`pre-code-wrapper ${className}`}>
      <CopyCodeButton preRef={preRef} />
      <pre ref={preRef} className={className} {...rest}>
        {children}
      </pre>
    </div>
  );
};

export default PreCodeBlock;
